import { useState } from "react";
import { ChevronDown, ChevronRight, BellOff, Bell, Check, Pencil, Sparkles } from "lucide-react";

const ICON = { created: Sparkles, update: Pencil, action: Check, reminders_off: BellOff, reminders_on: Bell };
const when = (iso) => {
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${String(d.getFullYear()).slice(2)} ${d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}`;
};
const dmy = (iso) => { const [y, m, d] = iso.split("-"); return `${d}/${m}/${y.slice(2)}`; };

// Chronological notes + action history for a hot lead.
export function LeadHistory({ lead }) {
  const log = lead.action_log || [];
  const [open, setOpen] = useState(false);
  if (!lead.notes && !log.length) return null;
  return (
    <div className="mt-2" data-testid={`hot-lead-history-${lead.id}`}>
      {lead.notes && <p className="text-xs text-white/60 leading-relaxed whitespace-pre-line" data-testid={`hot-lead-notes-text-${lead.id}`}>{lead.notes}</p>}
      {log.length > 0 && (
        <button type="button" onClick={() => setOpen((o) => !o)} data-testid={`hot-lead-history-toggle-${lead.id}`}
          className="mt-1.5 text-[11px] text-white/50 hover:text-white inline-flex items-center gap-1">
          {open ? <ChevronDown size={12} /> : <ChevronRight size={12} />} Notes & history ({log.length})
        </button>
      )}
      {open && (
        <ol className="mt-1.5 border-l border-white/10 pl-3 space-y-2">
          {log.map((e, i) => {
            const Icon = ICON[e.kind] || Check;
            return (
              <li key={i} className="relative text-xs" data-testid={`hot-lead-history-entry-${lead.id}-${i}`}>
                <Icon size={11} className="absolute -left-[19px] top-0.5 text-white/50 bg-surface" />
                <div className="text-white/80 whitespace-pre-line">{e.note}</div>
                <div className="text-[10px] text-white/40">{e.by_name} · {when(e.at)}{e.kind === "action" && e.next_action_date ? ` · next ${dmy(e.next_action_date)}` : ""}</div>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
